import { Pipe, PipeTransform } from '@angular/core';
import { Config, TranslateService } from '@app/services';
import { NumberSettings, formatNumber } from 'accounting';

@Pipe({
  name: '_number',
  pure: true,
  standalone: false,
})
export class NumberPipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  transform(value: any, decimals: number = 2, trailing: boolean = true): any {
    if (!value) {
      value = 0;
    }

    const config: Config = this.translateService.getConfig;

    const options: NumberSettings = {
      precision: decimals,
      thousand: '',
      decimal: config.number.decimal,
    };
    const number: string = formatNumber(+value, options);

    // const formatters = {
    //   default: new Intl.NumberFormat(config.locale, {
    //     style: 'decimal',
    //     minimumFractionDigits: decimals,
    //     maximumFractionDigits: decimals,
    //   }),
    // };
    // const number: string = formatters.default.format(value);

    if (trailing) {
      return this.removeTrailingZeros(number);
    } else {
      return number;
    }
  }

  removeTrailingZeros = (value: any) => {
    value = value.toString();
    const config: Config = this.translateService.getConfig;
    const separator: string = config.number.decimal;
    if (value.indexOf(separator) === -1) {
      return value;
    }
    while ((value.slice(-1) === '0' || value.slice(-1) === separator) && value.indexOf(separator) !== -1) {
      value = value.substr(0, value.length - 1);
    }
    return value;
  };
}
